<template>
  <div class="relative">
    <div class="group block w-full aspect-w-10 aspect-h-7 rounded-lg overflow-hidden">
      <img
        v-if="project.cover"
        :src="project.cover"
        alt=""
        class="group-hover:opacity-75 object-cover pointer-events-none"
      />
      <div
        v-else
        class="h-full bg-gray-500 group-hover:opacity-75 flex items-center justify-center"
      >
        <svg
          class="w-8 h-8 text-gray-300"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0
            012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2
            0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      </div>
      <button type="button" class="absolute inset-0 focus:outline-none" @click="viewDetails">
        <span class="sr-only">View details for {{ project.name }}</span>
      </button>
    </div>
    <p class="mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none">
      {{ project.name }}
    </p>
    <p v-if="client" class="block text-sm font-medium text-gray-500 pointer-events-none">
      {{ client.name }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    client() {
      if (!this.project?.client) {
        return null;
      }

      if (typeof this.project.client === 'object') {
        return this.project.client;
      }

      return this.$store.state.entities.accounts.byId[this.project.client] || null;
    },
  },
  methods: {
    viewDetails() {
      this.$emit('view', this.project);
    },
  },
};
</script>
